import React from "react";

import AcompanhamentoCargaMateriaPrimaTopo from "./topo";
import AcompanhamentoCargaMateriaPrimaDetalhes from "./detalhe";

/* Localização */
/*
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
*/

import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import br from "date-fns/locale/pt-BR";

import styles from './detail.module.css';

export default function AcompanhamentoCargaMateriaPrimaPage() {
  return (
    <React.Fragment>
      <div
        className={`container ${styles.container}`}
      >
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterlocale={br}>
          <AcompanhamentoCargaMateriaPrimaTopo />
          <AcompanhamentoCargaMateriaPrimaDetalhes />
        </LocalizationProvider>
      </div>
    </React.Fragment>
  );
}
